import { getIdToken } from "../../auth";

function apiBase(): string {
  const url = import.meta.env.VITE_API_FUNCTION_URL as string | undefined;
  if (!url) throw new Error("VITE_API_FUNCTION_URL is not set.");
  return url.replace(/\/$/, "");
}

async function jsonHeader(): Promise<HeadersInit> {
  const token = await getIdToken();
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
}

async function check(r: Response): Promise<Response> {
  if (!r.ok) {
    const body = await r.text().catch(() => r.statusText);
    throw new Error(`API ${r.status}: ${body.slice(0, 200)}`);
  }
  return r;
}

export async function setReminder(
  sessionId: string,
  nextReviewDate: number | null,
): Promise<{ nextReviewDate: number | null }> {
  const r = await check(
    await fetch(`${apiBase()}/canvas/${sessionId}/reminder`, {
      method: "POST",
      headers: await jsonHeader(),
      body: JSON.stringify({ nextReviewDate }),
    }),
  );
  return (await r.json()) as { nextReviewDate: number | null };
}
